import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter, FlexCenter, LineClamp } from '../../global/commonStyle';

interface Props {
  isInbox?: boolean;
  noMargin?: boolean;
  applyDottedText?: boolean;
  removeTitleSpacing?: boolean;
}

const Header = styled.div<Props>`
  padding: var(--space-8) var(--space-20) var(--space-0);
  background-color: var(--background-secondary);
  margin-inline: ${({ isInbox, noMargin }) => (isInbox ? '-8px' : noMargin ? 'var(--space-0)' : '-20px')};
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  z-index: var(--z-index-toast);
  width: calc(100vw - 40px);
`;

// Top Section styles
const TopSection = styled.div`
  display: flex;
  gap: var(--space-12);
  align-items: flex-start;
  justify-content: space-between;
`;

const SubTitle = styled.p`
  width: max-content;
  ${Typography.body_lg_medium}
  color: var(--text-secondary);
  margin-block: var(--space-2) var(--space-8);
`;

const TopRightSection = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const IconDiv = styled.div`
  padding: var(--space-6);
  ${FlexCenter}
`;

// Bottom Section styles
const BottomSection = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-12);
  padding-inline: ${({ removeTitleSpacing }) => (removeTitleSpacing ? 'var(--space-0)' : 'var(--space-20)')};
  margin-inline: ${({ isInbox, noMargin }) => (isInbox ? '-8px' : noMargin ? 'var(--space-0)' : '-20px')};
  padding-bottom: var(--space-8);
  background-color: var(--background-secondary);
`;

const BottomLeftSection = styled.div`
  ${FlexCenter}
`;

const BottomRightSection = styled.p<Props>`
  ${Typography.heading_xl_semibold}
  color: var(--text-primary);
  margin-block: var(--space-0);
  ${({ applyDottedText }) =>
    applyDottedText &&
    css`
      ${LineClamp(1)}
      word-break: break-all;
    `}
`;

// Add animation styles for header text transitions
const HeaderTexts = styled.div`
  position: relative;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const AnimatedSubTitle = styled(SubTitle)`
  position: absolute;
  left: 0;
  top: 0;
  transition: transform var(--transition-slow) cubic-bezier(0.4, 0, 0.2, 1),
    opacity var(--transition-slow) cubic-bezier(0.4, 0, 0.2, 1);
  &.scrolled {
    transform: translateY(-20px);
    opacity: 0;
    pointer-events: none;
  }
`;

const AnimatedTitle = styled(SubTitle)`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  transform: translateY(20px);
  transition: transform var(--transition-slow) cubic-bezier(0.4, 0, 0.2, 1),
    opacity var(--transition-slow) cubic-bezier(0.4, 0, 0.2, 1);
  &.scrolled {
    opacity: 1;
    transform: translateY(0);
  }
`;

export {
  Header,
  TopSection,
  SubTitle,
  TopRightSection,
  IconDiv,
  BottomSection,
  BottomLeftSection,
  BottomRightSection,
  HeaderTexts,
  AnimatedSubTitle,
  AnimatedTitle
};
